"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeServiceEngagementAssociation = exports.removePortalEngagementAssociation = exports.createServiceEngagementAssociation = exports.createPortalEngagementAssociation = void 0;

var ImmutableAPI = _interopRequireWildcard(require("crm_data/api/ImmutableAPI"));

var _AssociationCategoryTypes = require("crm_schema/association/AssociationCategoryTypes");

var API = 'associations-writes/v1/associations';
var engagementToPortalAssociationType = 'ENGAGEMENT_TO_PORTAL';
var engagementToServiceAssociationType = 'ENGAGEMENT_TO_BET_DELIVERABLE_SERVICE';
var serviceAssociationTypeId = 24;
var portalAssociationTypeId = 56;
var associationCategory = _AssociationCategoryTypes.HUBSPOT_DEFINED;

var makeURI = function makeURI() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return API + "/" + args.join('/');
};

var createEngagementAssociationRemover = function createEngagementAssociationRemover(associationType) {
  return function (engagementId, objectId) {
    return ImmutableAPI.delete(makeURI(engagementId, associationType, objectId));
  };
};

var createEngagementAssociationCreator = function createEngagementAssociationCreator(associationTypeId) {
  return function (engagementId, objectIds) {
    var associations = objectIds.map(function (id) {
      return {
        fromObjectId: engagementId,
        toObjectId: id,
        associationCategory: associationCategory,
        associationTypeId: associationTypeId
      };
    });
    return ImmutableAPI.put(API, associations);
  };
};

var createPortalEngagementAssociation = createEngagementAssociationCreator(portalAssociationTypeId);
exports.createPortalEngagementAssociation = createPortalEngagementAssociation;
var createServiceEngagementAssociation = createEngagementAssociationCreator(serviceAssociationTypeId);
exports.createServiceEngagementAssociation = createServiceEngagementAssociation;
var removePortalEngagementAssociation = createEngagementAssociationRemover(engagementToPortalAssociationType);
exports.removePortalEngagementAssociation = removePortalEngagementAssociation;
var removeServiceEngagementAssociation = createEngagementAssociationRemover(engagementToServiceAssociationType);
exports.removeServiceEngagementAssociation = removeServiceEngagementAssociation;